<div class="box-content">
  <h4 class="title">
    {{'ISSUE-TEXT.CREATE' | translate}} - {{(currentLang === 'en' ? document.nameEN : document.name)}}
  </h4>
</div>

<form [formGroup]="documentIssueForm" #documentIssueFormDir="ngForm" (ngSubmit)="submit()">
  <app-seller-form formControlName="sellerForm" [isSubmitted]="documentIssueFormDir.submitted"></app-seller-form>

  <app-document-form formControlName="documentForm"
      [documentInformation]="documentInformation"
      [documentType]="document.type"
      [isSubmitted]="documentIssueFormDir.submitted"
      [isDuplicateDocumentNo]="documentIssueForm.errors?.duplicateDocumentNo"
      (documentRequestSelected)="onDocumentRequestSelected($event)"
      [docProcessType]="docProcessType"
      (abbDataSelected)="onAbbDataSelected($event)">
  </app-document-form>

  <app-buyer-form formControlName="buyerForm"
      [branchID]="buyerBranchID"
      [isSubmitted]="documentIssueFormDir.submitted"
      [docProcessType]="docProcessType"
      [documentInformation]="documentInformation">
  </app-buyer-form>

  <app-line-item-form formControlName="lineItemForm"
    [documentType]="document.type"
    [isSubmitted]="documentIssueFormDir.submitted"
    [documentInformation]="documentInformation"
    [documentIssueForm]="documentIssueForm"
    [abbData]="abbData">
  </app-line-item-form>

  <div class="m-t-30 text-center">
    <button type="button" class="btn btn-dv btn-clean btn-wide m-r-5" (click)="data.emit(null)">
      <!-- TODO: change this if want to remove data -->
      <em class="fas fa-chevron-left m-r-5"></em>
      {{'ISSUE-TEXT.BACK' | translate}}
    </button>
    <button type="submit" class="btn btn-dv btn-wide">
      {{'ISSUE-TEXT.NEXT' | translate}}
      <em class="fas fa-chevron-right m-l-5"></em>
    </button>
    <br><br>
    <br><br>
  </div>
</form>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/document-issue-form/document-issue-form.component.html